// extracted by mini-css-extract-plugin
export default {"STHeader":"style_STHeader__8ek4u","STTitle":"style_STTitle__BN1wO"};